<template>
  <div>
    <div class="tabs"></div>
    <div class="layout-preview-container">
      <layout-preview id="layout-preview"></layout-preview>
    </div>
    <div class="bottom">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import LayoutPreview from './LayoutPreview.vue'

  export default {
    name: 'Product',
    components: {
      LayoutPreview,
    },
    methods: {
      ...mapMutations([
      ]),
    },
  }
</script>

<style lang="scss" scoped>
  #layout-preview {
    text-align: center;
    height: 227px;
    overflow: hidden;
  }
  .layout-preview-container{
    position: fixed;
    width: 100%;
    background-image: url(../../assets/images.jpg);
    z-index: 97;
  }
  .bottom {
    padding-top: 218px;
  }
  .tabs {
    position: fixed;
    top: 255px;
    left: 10px;
    z-index: 98;
    .tab-list {
      background-color: rgb(72,92,146);
      margin-right: 4px;
      padding: 6px 10px;
      color: #fff;
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
      cursor: pointer;
      &.active {
        background-color: #151d66;
      }
      &.disabled {
        opacity: .7;
      }
    }
  }
  @media (min-width: 800px) {
    #layout-preview {
      height: 380px;
    }
    .tabs {
      top: 410px;
    }
    .bottom {
      padding-top: 380px;
    }
  }
</style>
